<template>
  <div class="transaction-page">
    <div class="processing-status" v-if="isProcessing">
      <h1>{{ $t('RECEIPT_PAGE_TRANSACTION_PROCESSING') }}</h1>
      <div
        class="progress-message"
        v-html="$t('W2P_TRANSACTION_PROCESSING_MESSAGE')"
      ></div>
      <div class="spinner-container">
        <pn-spinner color="blue" size="medium"></pn-spinner>
      </div>
      <div class="process-icon">
        <img
          src="@/assets/images/letters/pay/mailouts-mailbox-processing.svg"
        />
      </div>
    </div>

    <div class="processing-status" v-if="!isProcessing && !isSuccess">
      <h1 v-if="!paymentDeclined">{{ $t('W2P_TRANSATION_FAIL_TITLE') }}</h1>
      <h1 v-if="paymentDeclined">{{ $t('W2P_PAY_PAYMENT_DECLINED') }}</h1>
      <div
        v-if="!paymentDeclined && !generalError"
        class="progress-message"
        v-html="
          $t('W2P_PLACE_ORDER_ERR_MESSAGE', { errString, cslink: getCSLink() })
        "
      ></div>
      <div
        class="progress-message"
        v-if="paymentDeclined"
        v-html="$t('W2P_PAY_PAYMENT_DECLINED_MESSAGE', { cslink: getCSLink() })"
      ></div>
      <div
        v-if="generalError"
        class="progress-message"
        v-html="$t('W2P_PAY_GENERIC_ERR_MESSAGE', { cslink: getCSLink() })"
      ></div>
      <div class="failed-icon">
        <img src="@/assets/images/letters/pay/mailouts-mailbox-error.svg" />
      </div>

      <div class="button-container">
        <pn-button-container secondary size="medium">
          <button @click="cancelOrBack('landing')">
            {{ $t('CANCEL') }}
          </button>
        </pn-button-container>

        <pn-button-container size="medium">
          <button class="next" @click="cancelOrBack('contactInformation')">
            {{ $t('GO_BACK') }}
          </button>
        </pn-button-container>
      </div>
    </div>

    <div class="success-status" v-if="!isProcessing && isSuccess">
      <div class="banner">
        <div class="title">
          <pn-icon
            symbol="check-circle"
            color="blue700"
            size="medium"
            solid
          ></pn-icon>
          <h2>
            {{
              $t('W2P_TRANSACTION_SUCCESS_TITLE', {
                orderId: successOrderId
              })
            }}
          </h2>
        </div>
        <div
          class="message"
          v-html="
            $t('W2P_TRANSACTION_SUCCESS_MESSAGE', {
              email: contactInformation.email
            })
          "
        ></div>

        <div class="success-icon">
          <img src="@/assets/images/letters/pay/mailouts-mailbox-success.svg" />
        </div>
      </div>
      <div class="order-info">
        <div class="pricing-info">
          <div class="details">
            <div
              class="name title"
              v-html="$t('W2P_TRANSACTION_TOTAL_PAID_INCL_VAT')"
            ></div>
            <div class="value title">
              {{ $n(totalPriceVAT, 'currency', 'sv-SE') }}
            </div>
          </div>
          <hr />
          <div class="details">
            <div class="name">
              {{ $t('W2P_TRANSACTION_BASE_PRICE') }}
              <p class="tiny">
                {{ $n(basePricePerPiece, 'currency', 'sv-SE') }}/{{
                  $t('W2P_PRODUCT_DEFINITION_PIECE')
                }}
                x {{ $n(numberOfRecipients) }} {{ $t('W2P_RECIPIENTS') }}
              </p>
            </div>
            <div class="value">
              {{ $n(basePrice, 'currency', 'sv-SE') }}
            </div>
          </div>
          <div class="details" v-for="extra in extras" :key="extra.name">
            <div class="name">
              {{ $t(extra.name) }}
              <p class="tiny">
                {{ $n(extra.pricePerPiece, 'currency', 'sv-SE') }}/{{
                  $t('W2P_PRODUCT_DEFINITION_PIECE')
                }}
                x {{ $n(numberOfRecipients) }} {{ $t('W2P_RECIPIENTS') }}
              </p>
            </div>
            <div class="value">
              {{ $n(extra.price, 'currency', 'sv-SE') }}
            </div>
          </div>

          <div class="details">
            <div class="name">
              {{ $t('W2P_TRANSACTION_POSTAGE') }}
              <p class="tiny">
                {{ $n(postagePricePerPiece, 'currency', 'sv-SE') }}/{{
                  $t('W2P_PRODUCT_DEFINITION_PIECE')
                }}
                x {{ $n(numberOfRecipients) }} {{ $t('W2P_RECIPIENTS') }}
              </p>
            </div>
            <div class="value">
              {{ $n(totalPostage, 'currency', 'sv-SE') }}
            </div>
          </div>
          <div class="details">
            <div class="name">
              {{ $t('W2P_TRANSACTION_TOTAL_EXCL_VAT') }}
            </div>
            <div class="value">
              {{ $n(totalPrice, 'currency', 'sv-SE') }}
            </div>
          </div>
          <hr />
        </div>

        <TableComponent :disabled="true"></TableComponent>

        <div class="button-container">
          <pn-button-container secondary size="medium">
            <button @click="backToLanding">
              {{ $t('W2P_TRANSACTION_CONTINUE_SHOPPING') }}
            </button>
          </pn-button-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from '@/components/letter/pay/preview/TableComponent.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    TableComponent
  },
  data() {
    return {
      isProcessing: true,
      isSuccess: false,
      errString: '',
      paymentDeclined: false,
      generalError: false,
      successOrderId: ''
    }
  },
  mounted() {
    if (!sessionStorage.getItem('orderPlaced')) {
      this.$store
        .dispatch('letter/pay/placeOrder')
        .then(res => {
          this.SET_SUCCESS_PAYMENT_STATE(res.data)
          sessionStorage.setItem('orderPlaced', 'true')

          if (this.paymentMethod !== 'invoice') {
            window.location.href = res.data.url
          } else {
            this.SET_PAYMENT_STATUS('processing')
            window.location.reload()
          }
        })
        .catch(err => {
          if (err.response.data.errorMessage.validOrder) {
            this.stitchErrors(err.response.data.errorMessage.validOrder)
          } else {
            this.generalError = true
          }
          this.isProcessing = false
          this.isSuccess = false
        })
    } else {
      switch (this.paymentStatus) {
        case 'unpaid':
          window.location.href = this.netsUrl
          break
        case 'processing':
          if (this.orderActivated) {
            this.isProcessing = false
            this.isSuccess = true
          } else {
            this.$store
              .dispatch('letter/pay/activateOrder')
              .then(res => {
                this.SET_SUCCESS_ACTIVATE_STATE(res.data.receiptUrl)
                this.isProcessing = false
                this.isSuccess = true

                this.$store.dispatch('cart/PUSH_GTM_PURCHASE', {
                  transactionId: this.transactionId
                })
              })
              .catch(err => {
                this.isProcessing = false
                this.isSuccess = false
                this.paymentDeclined = true
                this.SET_PAYMENT_STATUS('unpaid') // making sure that this is set
              })
          }
          break
      }
    }
  },
  updated() {
    /* Added because after successful order some customer use browser back button
       to create new order in which cart state is not reset. If the customer make 
       a new order the payment page will show up but order will not go through */
    if (
      this.orderActivated &&
      this.paymentStatus === 'success' &&
      sessionStorage.getItem('orderPlaced') &&
      this.cartId
    ) {
      this.successOrderId = this.cartId
      setTimeout(() => this.$store.dispatch('resetOrderState'), 1000)
    }
  },
  computed: {
    ...mapState(['lang', 'market']),
    ...mapState('letter/address', ['numberOfRecipients']),
    ...mapState('letter/pay', [
      'paymentStatus',
      'netsUrl',
      'orderId',
      'cartId',
      'orderActivated',
      'contactInformation',
      'paymentMethod',
      'transactionId'
    ]),
    ...mapState('cart', [
      'basePrice',
      'basePricePerPiece',
      'totalPostage',
      'postagePricePerPiece',
      'totalPrice',
      'extras',
      'totalPriceVAT'
    ])
  },

  methods: {
    ...mapMutations('letter/pay', [
      'SET_SUCCESS_PAYMENT_STATE',
      'SET_PAYMENT_STATUS',
      'SET_SUCCESS_ACTIVATE_STATE',
      'RESET_TRANSACTION_STATES',
      'RESET_CART'
    ]),
    backToLanding() {
      this.$store.dispatch('resetOrderState')
      this.$router.push({ name: 'landing' })
    },
    getCSLink() {
      const links = {
        SE: {
          0: 'https://www.postnord.se/en/help-and-support/contact-us',
          1: 'https://www.postnord.se/kontakta-oss'
        },
        DK: {
          0: 'https://www.postnord.dk/en/help-and-support',
          1: 'https://www.postnord.dk/kundeservice'
        }
      }

      const languages = {
        DK: 'da',
        SE: 'sv'
      }

      return links[this.market][Number(this.lang === languages[this.market])]
    },
    cancelOrBack(page) {
      this.RESET_CART()
      this.$router.push({ name: page })
    },
    stitchErrors(orderValidity) {
      const errArr = []
      const errorMessages = {
        validCustomerNumber: 'W2P_CUSTOMER_NUMBER',
        validDeliveryDay: 'W2P_DELIVERY_DAY',
        validPageCount: 'W2P_PAGE_COUNT',
        validPreflight: 'W2P_PDF',
        validProduct: 'PRODUCT'
      }

      Object.keys(errorMessages).forEach(item => {
        if (!orderValidity[item]) {
          errArr.push(this.$t(errorMessages[item]))
        }
      })

      this.errString = errArr.join(', ')
      if (errArr.length > 1) {
        this.errString = this.errString + ' ' + this.$t('W2P_ARE_INVALID')
      } else {
        this.errString = this.errString + ' ' + this.$t('W2P_IS_INVALID')
      }

      this.errString = this.errString.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.transaction-page {
  font-size: 1.6rem;

  .processing-status {
    .progress-message {
      margin-top: 4rem;
      color: $gray700;
      font-size: 0.875em;
    }

    .process-icon img {
      display: block;
      margin: 0 auto;
    }

    .failed-icon {
      padding: 4rem 0rem;

      img {
        display: block;
        margin: 0 auto;
      }
    }

    h1 {
      font-size: 1.25em;
      font-weight: 100;
    }

    padding: 3em 4em;
  }

  .success-status {
    .banner {
      padding: 3em 4em 0 4em;
      background-color: $blue200;
      color: $black;

      .title {
        display: flex;
        line-height: 1.5em;
        margin-bottom: 0.5em;

        pn-icon {
          margin-right: 0.5em;
        }
      }

      .message {
        font-size: 0.875em;
        font-weight: 300;
        line-height: 1.5em;
        margin-bottom: 0.5em;
      }

      pn-button-container {
        margin-bottom: 2em;
      }

      .success-icon img {
        display: block;
        margin: 0 auto;
      }
    }

    .order-info {
      width: 100%;
      padding: 3em 4em;

      .pricing-info {
        margin-bottom: 2em;

        .details {
          display: flex;
          margin-top: 0.58em;
          justify-content: space-between;
          color: $black;
          font-size: 0.875em;
          font-weight: 300;
          line-height: 1.5em;

          .name {
            &.title {
              font-size: 1.143em;
              font-weight: 500;
            }

            .tiny {
              color: $gray700;
            }
          }

          .value.title {
            font-size: 1.75em;
            color: $blue700;
            font-weight: 800;
          }
        }

        hr {
          margin-top: 1.5em;
          color: $gray200;
        }
      }
    }
  }
}

@media screen and (max-width: 50em) {
  .banner img {
    width: 100%;
  }

  .order-info {
    padding: 3em 0 !important;
  }
}
</style>
